<template>
  <!-- กระดิ่งแจ้งเตือน — ใช้ chrome ชุดเดียวกับตัวเลือกธีม/ภาษา (.theme-wrap / .theme-menu /
       .theme-scrim / .popmenu) เพื่อให้ปุ่มบนแถบบนหน้าตาเป็นชุดเดียวกันทั้งแถว

       กล่องแบ่ง 2 ส่วนตามสเปคที่เจ้าของเคาะ:
         "ปัจจุบัน"    = การ์ดที่ยังเป็นความจริงอยู่ — **อยู่ต่อแม้กดอ่านแล้ว**
         "ผ่านไปแล้ว" = ยุบไว้ กดกางดูย้อนหลังได้
       ⚠️ หัวข้อกลุ่มบนต้องเป็นกลาง ไม่ผูกกับ "นัดหมาย" — กล่องเดียวกันนี้ใส่ทั้งคาบสอนของโค้ช
       และการ์ดคอร์สของผู้ปกครอง (ที่ไม่มีวันนัด) เดิมเขียนว่า "นัดหมายที่กำลังจะถึง" แล้ว
       การ์ด "คอร์สหมดอายุแล้ว" ไปอยู่ใต้หัวข้อนั้น อ่านแล้วขัดกันเอง (เจ้าของทัก 5 ส.ค.)
       จุดที่ห้ามพลาด: การกดอ่านทำให้ badge ลด แต่ต้องไม่ทำให้การ์ดหาย ไม่งั้นโค้ชที่เผลอ
       กดตอนเช้าจะลืมคาบเย็น ซึ่งคือสิ่งที่ฟีเจอร์นี้ตั้งใจแก้พอดี (ตรรกะจริงอยู่ฝั่ง backend) -->
  <div class="theme-wrap noti-wrap" v-click-outside="() => { open = false }">
    <button class="lang-btn noti-btn" type="button" v-hint="$t('noti.title')" @click="toggle">
      <span class="mdi mdi-bell-outline"></span>
      <span v-if="unreadCount > 0" class="noti-dot">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
    </button>

    <template v-if="open">
      <div class="theme-scrim" @click="open = false"></div>
      <div class="popmenu theme-menu noti-menu">
        <div class="popmenu-head">
          <span class="popmenu-name"><span class="mdi mdi-bell-outline"></span> {{ $t('noti.title') }}</span>
          <button v-if="unreadCount > 0" type="button" class="noti-readall" @click="markAllRead">
            {{ $t('noti.markAllRead') }}
          </button>
        </div>

        <div class="noti-body">
          <!-- โหลดครั้งแรก: skeleton สั้น ๆ ไม่ใช้ overlay เต็มจอ (มาตรฐาน grid ของระบบ) -->
          <div v-if="loading && !loaded" class="noti-skel-wrap">
            <div v-for="i in 3" :key="i" class="id-skel noti-skel"></div>
          </div>

          <div v-else-if="!upcoming.length && !past.length" class="noti-empty">
            <span class="mdi mdi-bell-sleep-outline"></span>
            <span>{{ $t('noti.empty') }}</span>
          </div>

          <template v-else>
            <div v-if="upcoming.length" class="noti-sec">{{ $t('noti.upcoming') }}</div>
            <button v-for="n in upcoming" :key="n.notificationid" type="button"
              class="noti-item" :class="{ unread: !n.readflag }" @click="openItem(n)">
              <span class="noti-ico" :class="kindClass(n.ntype)">
                <span class="mdi" :class="kindIcon(n.ntype)"></span>
              </span>
              <span class="noti-tx">
                <span class="noti-t">{{ n.title }}</span>
                <span class="noti-b">{{ n.body }}</span>
                <span v-if="n.eventdate" class="noti-when">
                  <span class="mdi mdi-calendar-blank-outline"></span>{{ dayLabel(n.eventdate) }}
                </span>
              </span>
              <span v-if="!n.readflag" class="noti-unread-dot"></span>
            </button>

            <template v-if="past.length">
              <button type="button" class="noti-sec noti-sec-btn" @click="showPast = !showPast">
                <span>{{ $t('noti.past') }} ({{ past.length }})</span>
                <span class="mdi" :class="showPast ? 'mdi-chevron-up' : 'mdi-chevron-down'"></span>
              </button>
              <template v-if="showPast">
                <button v-for="n in past" :key="'p' + n.notificationid" type="button"
                  class="noti-item noti-item-past" @click="openItem(n)">
                  <span class="noti-ico noti-ico-past"><span class="mdi" :class="kindIcon(n.ntype)"></span></span>
                  <span class="noti-tx">
                    <span class="noti-t">{{ n.title }}</span>
                    <span class="noti-b">{{ n.body }}</span>
                  </span>
                </button>
              </template>
            </template>
          </template>
        </div>

        <!-- เปิด/ปิดการเด้งเตือนขึ้นจอ (Web Push) — วางไว้ในกล่องแจ้งเตือนเพราะเป็นที่ที่
             ผู้ใช้กำลังคิดเรื่องนี้อยู่พอดี · ซ่อนทั้งบล็อกเมื่อ backend ยังไม่ได้ตั้ง VAPID
             (ไม่มีทางสำเร็จ อย่าให้ผู้ใช้กดแล้วพังเงียบ ๆ) -->
        <div v-if="pushCfg.enabled && pushStatus !== 'unsupported'" class="noti-push">
          <template v-if="pushStatus === 'ios-install'">
            <div class="noti-push-hint">
              <span class="mdi mdi-export-variant"></span>
              <span>{{ $t('noti.pushIosHint') }}</span>
            </div>
          </template>
          <template v-else-if="pushStatus === 'blocked'">
            <div class="noti-push-hint">
              <span class="mdi mdi-bell-off-outline"></span>
              <span>{{ $t('noti.pushBlocked') }}</span>
            </div>
          </template>
          <template v-else>
            <button type="button" class="noti-push-btn" :disabled="pushBusy" @click="togglePush">
              <span class="mdi" :class="pushStatus === 'on' ? 'mdi-bell-check' : 'mdi-bell-plus-outline'"></span>
              <span class="noti-push-tx">
                <span class="noti-push-t">{{ pushStatus === 'on' ? $t('noti.pushOn') : $t('noti.enablePush') }}</span>
                <span class="noti-push-d">{{ pushStatus === 'on' ? $t('noti.pushOff') : $t('noti.pushDesc') }}</span>
              </span>
            </button>
            <div v-if="pushError" class="noti-push-hint noti-push-err">
              <span class="mdi mdi-alert-circle-outline"></span><span>{{ pushError }}</span>
            </div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import axios from 'axios';
import live from '@/utils/live'
import { pushState, enablePush, disablePush } from '../../utils/push';

// ทุก 60 วิ — มาตรฐานโพลเงียบของระบบ (Dashboard / BookingManagement / PrivateBookingList /
// CoachLeave ใช้ค่าเดียวกันหมด) เงียบจริง: ไม่ขึ้น skeleton ไม่เด้ง error dialog
const POLL_MS = 60000;

// ไอคอน/สีต่อชนิดการแจ้งเตือน — ntype ที่ไม่รู้จัก (เพิ่มใหม่ฝั่ง backend ก่อนที่หน้าจอจะตามทัน)
// ตกไปที่ค่ากลาง ไม่พัง ไม่หาย
const KIND = {
  'private.assigned': { icon: 'mdi-account-heart-outline', cls: 'k-ok' },
  'private.moved': { icon: 'mdi-calendar-sync-outline', cls: 'k-warn' },
  // ถูกเปลี่ยนตัวออก ใช้หน้าตาเดียวกับ "ยกเลิก" ตามที่เจ้าของสั่ง — ข้อความฝั่ง backend
  // ก็เป็นคำเดียวกันแล้ว ถ้าไอคอน/สีต่างกันการ์ดสองใบที่เขียนเหมือนกันจะดูไม่เข้าพวก
  'private.unassigned': { icon: 'mdi-calendar-remove-outline', cls: 'k-err' },
  'private.cancelled': { icon: 'mdi-calendar-remove-outline', cls: 'k-err' },
  // ── ถึงผู้ปกครอง: คอร์สใกล้หมด/หมดอายุ (ยิงจาก cron ฝั่ง backend วันละครั้ง) ──
  // สีตรงกับแถบเดิมที่เคยอยู่บนหน้าแรก: หมดแล้ว = แดง · ยังทันแต่ต้องรีบ = ส้ม
  'course.expired': { icon: 'mdi-ticket-outline', cls: 'k-err' },
  'course.low': { icon: 'mdi-ticket-percent-outline', cls: 'k-warn' },
  'course.expiring': { icon: 'mdi-calendar-clock', cls: 'k-warn' },
  // แอดมินแก้วันหมดอายุ (ส้ม: ต้องจดวันใหม่ — โทนเดียวกับ "ย้ายคาบ"/"อีเวนต์เลื่อนวัน")
  'course.expiry_changed': { icon: 'mdi-calendar-edit-outline', cls: 'k-warn' },
  // คำขอเลื่อนวันหมดอายุ: ถึงผู้จัดการ (รอตัดสิน = ส้ม) · ถึงผู้ยื่น (ตัดสินแล้ว = น้ำเงินกลาง ๆ)
  'admin.expiry_request': { icon: 'mdi-calendar-clock', cls: 'k-warn' },
  'admin.expiry_decided': { icon: 'mdi-calendar-check-outline', cls: 'k-ok' },
  // ── ถึงผู้ปกครอง: อีเวนต์/แข่งขัน (สมัครสำเร็จ = เขียว · ค้างชำระ = ส้ม · รับเงินแล้ว = เขียว) ──
  'event.registered': { icon: 'mdi-trophy-outline', cls: 'k-ok' },
  'event.unpaid': { icon: 'mdi-cash-clock', cls: 'k-warn' },
  'event.paid': { icon: 'mdi-cash-check', cls: 'k-ok' },
  // เฟส 5 — เลื่อนวัน (ส้ม: ต้องจดวันใหม่) · ยกเลิกทั้งงาน (แดง: ไม่มีงานแล้ว)
  'event.moved': { icon: 'mdi-calendar-sync-outline', cls: 'k-warn' },
  'event.cancelled': { icon: 'mdi-calendar-remove-outline', cls: 'k-err' },
};

export default {
  name: 'NotificationBell',
  data() {
    return {
      open: false,
      showPast: false,
      loading: false,
      loaded: false,
      unreadCount: 0,
      upcoming: [],
      past: [],
      interval: null,
      // Web Push — cfg มาจาก backend (ปิดอยู่ถ้ายังไม่ตั้ง VAPID_* บนเซิร์ฟเวอร์)
      pushCfg: { enabled: false, publicKey: null },
      pushStatus: 'off', // off | on | blocked | ios-install | unsupported
      pushBusy: false,
      pushError: '',
    };
  },
  created() {
    this.fetch();
  },
  mounted() {
    // โพลเงียบเบื้องหลัง — เหมือนหน้าอื่นในระบบ · **ห้ามเอาออก** สายเรียลไทม์เป็นของแถม
    this.interval = setInterval(() => this.fetch(true), POLL_MS);
    // การ์ดกระดิ่งส่งถึงเจ้าของคนเดียวเท่านั้น (ฝั่งเซิร์ฟเวอร์ใส่ `to` ให้) จึงไม่มีการปลุก
    // ทุกเครื่องเวลาคนอื่นกดอ่านการ์ดของตัวเอง
    this.offLive = live.subscribe('notification', () => this.fetch(true));
  },
  beforeUnmount() {
    clearInterval(this.interval);
    if (this.offLive) this.offLive();
  },
  methods: {
    // silent = โพลเบื้องหลัง: ห้ามขึ้น skeleton และห้ามเด้ง error ให้ผู้ใช้เห็น
    async fetch(silent) {
      const token = this.$store.getters.getToken;
      if (!token) return;
      if (!silent) this.loading = true;
      try {
        const res = await axios.post(this.baseURL + '/getMyNotifications', {},
          { headers: { Authorization: 'Bearer ' + token } });
        if (res.data && res.data.success) {
          this.unreadCount = res.data.unreadCount || 0;
          this.upcoming = res.data.upcoming || [];
          this.past = res.data.past || [];
          this.loaded = true;
        }
      } catch (e) {
        // เงียบโดยตั้งใจ — กระดิ่งพังต้องไม่ขวางการทำงานของหน้าที่ผู้ใช้กำลังใช้อยู่
      } finally {
        this.loading = false;
      }
    },
    toggle() {
      this.open = !this.open;
      if (this.open) {
        this.fetch(); // เปิดกล่อง = ดึงของสดเสมอ ไม่รอรอบโพล
        this.refreshPush();
      }
    },

    // ── Web Push ────────────────────────────────────────────────────────────
    // เช็คตอนเปิดกล่องเท่านั้น ไม่เช็คตอน created: ไม่ควรไปแตะ serviceWorker/Notification
    // ของทุกคนที่ล็อกอินตั้งแต่วินาทีแรก ทั้งที่ส่วนใหญ่ไม่ได้จะเปิดใช้
    async refreshPush() {
      const token = this.$store.getters.getToken;
      if (!token) return;
      try {
        const res = await axios.post(this.baseURL + '/getPushConfig', {},
          { headers: { Authorization: 'Bearer ' + token } });
        if (res.data && res.data.success) {
          this.pushCfg = { enabled: !!res.data.enabled, publicKey: res.data.publicKey };
        }
      } catch (e) { this.pushCfg = { enabled: false, publicKey: null }; }
      this.pushStatus = await pushState();
    },
    async togglePush() {
      this.pushBusy = true;
      this.pushError = '';
      const token = this.$store.getters.getToken;
      const auth = { headers: { Authorization: 'Bearer ' + token } };
      try {
        if (this.pushStatus === 'on') {
          await disablePush({
            remove: (endpoint) => axios.post(this.baseURL + '/deletePushSubscription', { endpoint }, auth),
          });
        } else {
          const r = await enablePush({
            publicKey: this.pushCfg.publicKey,
            save: (sub) => axios.post(this.baseURL + '/savePushSubscription', sub, auth),
          });
          if (!r.ok) {
            const MSG = {
              'ios-install': 'noti.pushIosHint', blocked: 'noti.pushBlocked',
              unsupported: 'noti.pushUnsupported',
            };
            this.pushError = this.$t(MSG[r.reason] || 'noti.pushFail');
          }
        }
      } catch (e) {
        this.pushError = this.$t('noti.pushFail');
      } finally {
        this.pushStatus = await pushState();
        this.pushBusy = false;
      }
    },
    kindIcon(ntype) { return (KIND[ntype] || {}).icon || 'mdi-bell-outline'; },
    kindClass(ntype) { return (KIND[ntype] || {}).cls || 'k-info'; },
    // eventdate มาจาก backend เป็น 'YYYY-MM-DD' อยู่แล้ว — ส่งให้ $formatShortDate ตรง ๆ
    // (ห้าม new Date() แล้ว format เอง: จะโดน timezone ของเครื่องผู้ใช้เลื่อนวัน)
    dayLabel(d) { return this.$formatShortDate(d); },

    async markRead(n) {
      if (!n || n.readflag) return;
      const token = this.$store.getters.getToken;
      try {
        await axios.post(this.baseURL + '/markNotificationRead', { notificationid: n.notificationid },
          { headers: { Authorization: 'Bearer ' + token } });
        // อัปเดตในที่ทันที: การ์ด "ยังอยู่" แค่เปลี่ยนสถานะเป็นอ่านแล้ว
        n.readflag = 1;
        this.unreadCount = Math.max(0, this.unreadCount - 1);
      } catch (e) { /* เงียบ */ }
    },
    async markAllRead() {
      const token = this.$store.getters.getToken;
      try {
        await axios.post(this.baseURL + '/markNotificationRead', { all: true },
          { headers: { Authorization: 'Bearer ' + token } });
        this.upcoming.forEach((n) => { n.readflag = 1; });
        this.unreadCount = 0;
      } catch (e) { /* เงียบ */ }
    },

    // กดการ์ด → ทำเครื่องหมายว่าอ่านแล้ว + บอก App.vue ว่าจะไปดูเรื่องอะไร ของวันไหน
    //
    // ⚠️ ห้ามเดาปลายทางจาก usertype ที่นี่ ถึงแม้ตอนนี้จะอ่าน usertype ได้แล้วก็ตาม
    // (`$store.getters.getUserdata` เคยเป็น null เสมอเพราะ mutation `setToken` รับ
    // `{token, user}` แต่ action ส่ง `{token, userdata}` มาให้ — แก้ที่ store/index.js แล้ว)
    // ครั้งแรกโค้ดนี้เดา usertype จากตรงนั้น ผลคือโค้ชทุกคนถูกส่งไปหน้าจัดการจอง Private
    // แล้วเจอ "ไม่มีสิทธิ์เข้าถึงหน้านี้" — เหตุผลที่ห้ามเดาไม่ได้อยู่ที่ getter พังหรือไม่
    // แต่อยู่ที่ usertype ไม่ได้บอกว่าเปิดเมนูไหนให้คนนั้นไว้บ้าง
    //
    // ส่งแค่ "เรื่องอะไร + วันไหน" ให้ App.vue เลือกหน้าปลายทางเอง — ที่นั่นมี myMenus/
    // allowedStates ของจริงอยู่แล้ว จึงตัดสินได้จาก "สิทธิ์ที่มี" ไม่ใช่จากการเดา role
    openItem(n) {
      this.markRead(n);
      this.open = false;
      this.$emit('go', { refkind: n.refkind, refid: n.refid, date: n.eventdate });
    },
  },
};
</script>

<style scoped>
.noti-wrap {
  position: relative;
  display: inline-flex;
}
.noti-btn {
  position: relative;
  padding: 0 10px;
}
/* ตัวเลขบนกระดิ่ง — ใช้ --c-error เหมือน .badge-error ของหน้าอื่น ไม่ hardcode สี */
.noti-dot {
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: var(--c-error);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
  box-shadow: 0 0 0 2px var(--c-surface);
}
.noti-menu {
  min-width: 328px;
  max-width: 92vw;
}
@media (max-width: 560px) {
  /* .theme-menu already pins to the viewport at this breakpoint (istar-themes.css);
     this min/max-width would otherwise still force it wider than the fixed left/right
     insets on narrow phones. */
  .noti-menu {
    min-width: 0;
    max-width: none;
  }
}
.noti-body {
  max-height: 60vh;
  overflow-y: auto;
  overflow-x: hidden;
}
.noti-sec {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 10px 4px;
  font-size: 11.5px;
  font-weight: 700;
  color: var(--c-text-muted);
  letter-spacing: .02em;
}
.noti-sec-btn {
  width: 100%;
  border: none;
  background: transparent;
  cursor: pointer;
  font-family: inherit;
  border-top: 1px dashed var(--c-border);
  margin-top: 4px;
  padding-top: 8px;
}
.noti-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  padding: 9px 10px;
  border: none;
  background: transparent;
  border-radius: var(--radius-sm);
  cursor: pointer;
  text-align: left;
  font-family: inherit;
}
.noti-item:hover {
  background: var(--c-surface-3);
}
.noti-item.unread {
  background: var(--c-surface-2);
}
.noti-ico {
  flex: 0 0 30px;
  width: 30px;
  height: 30px;
  border-radius: 999px;
  display: grid;
  place-items: center;
  background: var(--c-surface-3);
}
.noti-ico .mdi {
  font-size: 17px;
}
.noti-ico.k-ok .mdi { color: var(--c-success); }
.noti-ico.k-warn .mdi { color: var(--c-warning); }
.noti-ico.k-err .mdi { color: var(--c-error); }
.noti-ico.k-info .mdi { color: var(--c-info); }
.noti-ico-past .mdi { color: var(--c-text-muted); }
.noti-tx {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1;
  /* white-space:nowrap is inherited from .popmenu-item; without resetting it here
     .noti-b's overflow-wrap:break-word has nothing to wrap onto and the long body
     text (e.g. multiple children's names) forces the popup wider instead. */
  white-space: normal;
}
.noti-t {
  font-size: 13.5px;
  font-weight: 700;
  color: var(--c-text-heading);
  font-family: var(--font-head);
}
/* ข้อความยาว (ชื่อเด็กหลายคน) ต้องตัดบรรทัดในกล่อง ไม่ดันกล่องกว้างจนล้นจอ */
.noti-b {
  font-size: 12.5px;
  color: var(--c-text-body);
  line-height: 1.4;
  overflow-wrap: break-word;
}
.noti-when {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11.5px;
  color: var(--c-text-muted);
  margin-top: 1px;
}
.noti-when .mdi { font-size: 13px; }
.noti-item-past { opacity: .62; }
.noti-unread-dot {
  flex: 0 0 8px;
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: var(--c-primary);
  margin-top: 11px;
}
.noti-readall {
  border: none;
  background: transparent;
  color: var(--c-primary);
  font-size: 11.5px;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;
  padding: 0;
}
.noti-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 22px 12px;
  color: var(--c-text-muted);
  font-size: 12.5px;
}
.noti-empty .mdi { font-size: 26px; }
.noti-skel-wrap { padding: 6px; display: flex; flex-direction: column; gap: 8px; }
.noti-skel { height: 42px; border-radius: var(--radius-sm); }
.popmenu-head .mdi { font-size: 15px; color: var(--c-primary); }

/* แถบเปิด/ปิดการเด้งเตือนขึ้นจอ — ท้ายกล่อง คั่นด้วยเส้นประเหมือน .popmenu-head */
.noti-push {
  border-top: 1px dashed var(--c-border);
  margin-top: 4px;
  padding-top: 6px;
}
.noti-push-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 8px 10px;
  border: none;
  background: transparent;
  border-radius: var(--radius-sm);
  cursor: pointer;
  text-align: left;
  font-family: inherit;
}
.noti-push-btn:hover:not(:disabled) { background: var(--c-surface-3); }
.noti-push-btn:disabled { opacity: .6; cursor: default; }
.noti-push-btn .mdi { font-size: 19px; color: var(--c-primary); flex: 0 0 auto; }
.noti-push-tx { display: flex; flex-direction: column; gap: 1px; min-width: 0; }
.noti-push-t { font-size: 12.5px; font-weight: 700; color: var(--c-text-heading); }
.noti-push-d { font-size: 11px; color: var(--c-text-muted); line-height: 1.35; }
.noti-push-hint {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin: 2px 4px 4px;
  padding: 8px 10px;
  border-radius: var(--radius-sm);
  background: var(--c-surface-2);
  font-size: 11.5px;
  line-height: 1.4;
  color: var(--c-text-muted);
}
.noti-push-hint .mdi { font-size: 15px; color: var(--c-primary); flex: 0 0 auto; margin-top: 1px; }
.noti-push-err .mdi { color: var(--c-error); }
</style>
